import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { onVerifiedCode } from '../utils/onVerifiedCode';
import { onChangePhoneNumber } from '../utils/onChangePhoneNumber';

import RouterTrackerForAnalytics from '../../../lib/utils/RouterTrackerForAnalytics'; // [MEMO] 구글 애널리틱스 라우터 트래커

import { Button } from '../../../components/UI/Button/Long';
import { CorpID } from '../../../lib/utils/corpid';

const ChangePhoneNumberPage = () => {
  const $title = document.head.querySelector('title');
  $title!.innerText = '전화번호 변경';
  RouterTrackerForAnalytics();

  const token = sessionStorage.getItem('token');

  const [userName, setUserName] = useState('');
  const [regNum, setRegNum] = useState('');
  const [oldPhoneNumber, setOldPhoneNumber] = useState('');
  const [currentPhoneNumber, setCurrentPhoneNumber] = useState('');

  const [verifiedCode, setVerifiedCode] = useState('');

  const onChangeUserName = (e: React.ChangeEvent<HTMLInputElement>) => {
    const target = e.target.value.toString();
    setUserName(target);
  };

  const onChangeRegNum = (e: React.ChangeEvent<HTMLInputElement>) => {
    const target = e.target.value.toString();
    setRegNum(target);
  };

  const onChangeOldPhoneNumber = (e: React.ChangeEvent<HTMLInputElement>) => {
    const target = e.target.value.toString();
    setOldPhoneNumber(target);
  };

  const onChangeCurrentPhoneNumber = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const target = e.target.value.toString();
    setCurrentPhoneNumber(target);
  };

  const onChangeVerifiedCode = (e: React.ChangeEvent<HTMLInputElement>) => {
    const target = e.target.value.toString().trim();
    setVerifiedCode(target);
  };

  return (
    <Section>
      <Wrap>
        <ItemBox>
          <ItemName>관리(단지)번호(6자리)</ItemName>
          <Input
            onChange={e => onChangeUserName(e)}
            type="text"
            placeholder="관리(단지)번호(6자리)를 입력해주세요"
          />
        </ItemBox>

        <ItemBox>
          <ItemName>이전 관리자 휴대폰 번호 [초기번호는 대표번호입니다.]</ItemName>
          <Input
            onChange={e => onChangeOldPhoneNumber(e)}
            type="text"
            placeholder="이전 관리자 휴대폰 번호를 입력해주세요"
          />
        </ItemBox>

        <ItemBox>
          <ItemName>현재 관리자 휴대폰 번호</ItemName>
          <div style={{ position: 'relative' }}>
            <Input
              onChange={e => onChangeCurrentPhoneNumber(e)}
              type="text"
              placeholder="변경하려는 번호를 입력해주세요"
            />
            <InsideButton
              onClick={() => {
                onVerifiedCode({
                  userName,
                  oldPhoneNumber,
                  currentPhoneNumber,
                });
              }}
            >
              인증번호 받기
            </InsideButton>
          </div>
        </ItemBox>

        <ItemBox>
          <ItemName>인증번호</ItemName>
          <div style={{ position: 'relative' }}>
            <Input
              onChange={e => onChangeVerifiedCode(e)}
              type="text"
              placeholder="인증번호 입력"
            />
            <CountdownNum>{/* 00:00 */}</CountdownNum>
          </div>
        </ItemBox>

        <ButtonSection>
          <div>
            <Button
              onClick={() =>
                onChangePhoneNumber({
                  userName,
                  regNum,
                  oldPhoneNumber,
                  currentPhoneNumber,
                  verifiedCode,
                })
              }
              label="전화번호 변경"
            />
          </div>
          <div style={{ marginLeft: '5px' }}>
            <Button
              onClick={() => {
                window.close();
              }}
              label="현재화면 닫기"
            />
          </div>
        </ButtonSection>
      </Wrap>
      <UpdateInfo>{CorpID(window.location.origin, "CorpID")}</UpdateInfo>
    </Section>
  );
};

export default ChangePhoneNumberPage;

const Section = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  width: 450px;
  padding: 50px 30px;
  border: solid 1px ${({ theme }) => theme.backgroundColor.gray};
  border-radius: 0.5em;
`;

const ItemBox = styled.div`
  margin: 10px 0;
  width: 100%;
`;

const ItemName = styled.div`
  margin-bottom: 10px;
  color: ${({ theme }) => theme.fontColor.black};
  font-size: 14px;
  font-weight: 500;
`;

const Input = styled.input`
  display: inline-block;
  background-color: white;
  border: solid 1px ${({ theme }) => theme.backgroundColor.shadowGray};
  border-radius: 0.5em;
  color: ${({ theme }) => theme.fontColor.black};

  padding: 10px 15px;
  width: 100%;

  ::placeholder {
    color: #a0a0a0;
  }
`;

const InsideButton = styled.button`
  position: absolute;
  top: 50%;
  right: 15px;
  padding: 5px;
  background-color: #ededed;
  border-radius: 0.5em;
  border: solid 1px #c1c1c1;
  color: #717171;
  font-size: 13px;
  font-weight: 500;
  transform: translateY(-50%);
  cursor: pointer;
`;

const CountdownNum = styled.div`
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
  font-size: 13px;
`;

const ExplainBox = styled.div`
  color: ${({ theme }) => theme.fontColor.gray};
  font-size: 13px;
`;

const ExplainText = styled.div`
  margin-top: 5px;
`;

const ButtonSection = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 10px;
  width: 100%;
`;

const UpdateInfo = styled.div`
  display: flex;
  justify-content: right;
  width: 450px;
  color: #c1c1c1;
  font-size: 12px;
  font-weight: 400;
`;
